// Template Generated by DataExtraction.py at 1716507313

import TransferEnglish5 from "../../Forms/Transfer/Transfer_English5.png";
import TransferEnglish5Labels from "../../Labels/Transfer/Transfer_English5.json";
import TransferFrench5 from "../../Forms/Transfer/Transfer_French5.png";
import TransferFrench5Labels from "../../Labels/Transfer/Transfer_French5.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale, isAnotherGender, drawText as drawTextAtPos
} from "../../PDFGenerationUtils";
import { t } from "i18next";

import { PLAN_TYPE_IDS, POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench5Labels : TransferEnglish5Labels;
    const formImage = isFrench ? TransferFrench5 : TransferEnglish5;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const beneficiary = data.beneficiary;
    const common = data.common;
    const plan = data.plan;

    let bSIN = beneficiary.sin;

    // split sins every 3 characters and if sin is an empty string, set it to empty string
    bSIN = bSIN.match(/.{1,3}/g) || [""];

    // add spaces between each sin
    bSIN = bSIN.join(" ");

    const dateFormat = "YYYY-MM-DD"

    // drawTextAtPos(doc, 12, t("Children's Education Funds Inc."), 52 / 3.38, 182 / 3.38, 231 / 3.38);
    // drawTextAtPos(doc, 12, t("3221 North Service Road"), 52 / 3.38, 230 / 3.38, 259 / 3.38);
    // drawTextAtPos(doc, 12, t("Burlington"), 52 / 3.38, 270 / 3.38, 184 / 3.38);
    // drawTextAtPos(doc, 12, t("ON"), 259 / 3.38, 269 / 3.38, 189 / 3.38);
    // drawTextAtPos(doc, 12, t("Transfer Department"), 52 / 3.38, 305 / 3.38, 185 / 3.38);
    // drawTextAtPos(doc, 12, t("L7N 3G2"), 490 / 3.38, 265 / 3.38, 177 / 3.38);
    // drawTextAtPos(doc, 12, t("800-246-1203"), 491 / 3.38, 315 / 3.38, 114 / 3.38);
    // drawTextAtPos(doc, 12, t("1"), 636 / 3.38, 680 / 3.38, 17 / 3.38);

    drawText(t("Children's Education Funds Inc."), "rPromotorName")
    drawText(t("3221 North Service Road"), "rPromotorAddress")
    drawText(t("Burlington"), "rPromotorCity")
    drawText(t("ON"), "rPromotorProvince")
    drawText(t("Transfer Department"), "rPromotorDepartment")
    drawText(t("L7N 3G2"), "rPromotorPostalCode")
    drawText(t("800-246-1203"), "rPromotorNumber")
    drawText(t("1"), "numBenes")

    // Drawing the form
    // TODO implement fields
    drawText(moment(beneficiary.birthdate).format(dateFormat), "bBirthdate");
    fillCheckbox(isFemale(beneficiary.gender), "bFemale");
    drawText(beneficiary.firstName, "bFirstName");
    drawText(beneficiary.lastName, "bLastName");
    fillCheckbox(isMale(beneficiary.gender), "bMale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "bAnother");

    if (plan.planTypeID == PLAN_TYPE_IDS.GROUP) {
        drawText("1047001", "bRespType");
        fillCheckbox(true, "bRespTypeG");

    } else if (plan.planTypeID == PLAN_TYPE_IDS.SI) {
        drawText("1047002", "bRespType");
        fillCheckbox(true, "bRespTypeI");

    } else if (plan.planTypeID == PLAN_TYPE_IDS.ACHIEVERS) {
        drawText("1047003", "bRespType");
        fillCheckbox(true, "bRespTypeI");
    }


    drawText(bSIN, "bSIN");
    drawText(subscriber.firstName, "s1FirstName2");
    drawText(subscriber.lastName, "s1LastName2");
    if (common.subscriber2Include) {
        drawText(jointSubscriber.firstName, "s2FirstName2");
        drawText(jointSubscriber.lastName, "s2LastName2");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench5Labels : TransferEnglish5Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
